var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1367",
    "data-name": "Groupe 1367",
    transform: "translate(-72.475 -53.717)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(72.475 53.717)",
    fill: "#fcb5c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1368",
    "data-name": "Groupe 1368",
    transform: "translate(0.304 -0.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CROIX",
    transform: "translate(80.687 98.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_959",
    "data-name": "Trac\\xE9 959",
    d: "M10.337,12.338-1.106.977a1.48,1.48,0,0,1,0-2.038,1.51,1.51,0,0,1,2.043,0L12.38,10.3a1.376,1.376,0,0,1,0,2.038A1.437,1.437,0,0,1,10.337,12.338Z",
    transform: "translate(11.564 -34.913) rotate(90)",
    fill: "#c9124a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CROIX-2",
    "data-name": "CROIX",
    transform: "translate(57.418 62.93) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_959-2",
    "data-name": "Trac\\xE9 959",
    d: "M10.337,12.338-1.106.977a1.48,1.48,0,0,1,0-2.038,1.51,1.51,0,0,1,2.043,0L12.38,10.3a1.376,1.376,0,0,1,0,2.038A1.437,1.437,0,0,1,10.337,12.338Z",
    transform: "translate(11.564 -34.913) rotate(90)",
    fill: "#c9124a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e06812ab7e936c6861c5e014deee18be.svg";
export { ForwardRef as ReactComponent };